import { render, staticRenderFns } from "./student.pug?vue&type=template&id=02254680&scoped=true&lang=pug&"
import script from "./student.ts?vue&type=script&lang=ts&"
export * from "./student.ts?vue&type=script&lang=ts&"
import style0 from "./student.styl?vue&type=style&index=0&id=02254680&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02254680",
  null
  
)

export default component.exports